module.exports = __webpack_public_path__ + "static/media/Group 7-A3.9a57bde0.svg";